<template>
    <div class="LayoutDefault container-fluid px-0">
        <div class="version-banner">
            <span class="version-banner__text">
                <font-awesome-icon
                    icon="bullhorn"
                    class="version-banner__emoji"
                    aria-hidden="true"
                />
                ¡Estrenamos nueva versión de Cronomancha! Más rápida y con mejor diseño.
                <font-awesome-icon
                    icon="running"
                    class="version-banner__sport-icon version-banner__sport-icon--run"
                    aria-hidden="true"
                />
                <font-awesome-icon
                    icon="biking"
                    class="version-banner__sport-icon version-banner__sport-icon--bike"
                    aria-hidden="true"
                />
            </span>
            <a
                href="https://resultados-app.cronomancha.com"
                target="_blank"
                rel="noopener noreferrer"
                class="version-banner__cta"
            >
                Probar ahora
            </a>
        </div>
        <b-navbar class="modern-nav">
            <b-navbar-brand href="#" class="modern-nav__brand">
                <img class="modern-logo" alt="cronomancha logo" src="../assets/logo-transparente.png">
            </b-navbar-brand>
            <b-navbar-nav class="modern-nav__title-wrap">
                <h2 class="modern-title d-none d-md-inline-block">{{carrera}}</h2>
                <h4 class="modern-title modern-title--sm d-inline-block d-md-none">{{carrera}}</h4>
            </b-navbar-nav>
            <b-navbar-nav class="ms-auto">
                <b-button class="modern-inicio-btn" v-on:click="goHome">Inicio</b-button>
            </b-navbar-nav>
        </b-navbar>

        <main class="LayoutDefault__main">
            <slot>

            </slot>
        </main>
        <footer class="LayoutDefault__footer">
            <span class="footer-copy">&copy;</span>
            <span class="footer-brand">cronomancha</span>
        </footer>
    </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

const VERSION_BANNER_KEY = 'cronomancha:versionBannerDismissed';

export default defineComponent({
    setup() {

    },
    data() {
        return {
            showVersionBanner: window.localStorage.getItem(VERSION_BANNER_KEY) !== '1'
        }
    },
    methods: {
        goHome: function(){
            let $vm = this;
            $vm.$router.push('/');
        },
        dismissVersionBanner() {
            this.showVersionBanner = false;
            window.localStorage.setItem(VERSION_BANNER_KEY, '1');
        }
    },
    computed: {
        // Regresa el nombre de la carrera, directo desde el store
        carrera() {
            return this.$store.getters.carrera
        }
    }
})
</script>

<style scoped>
.version-banner {
    position: sticky;
    top: 0;
    z-index: 1030;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 0.55rem 2.75rem 0.55rem 1rem;
    background: linear-gradient(90deg, #f80606, #b30505);
    color: #fff;
    font-weight: 500;
    text-align: center;
    box-shadow: 0 2px 10px rgba(248, 6, 6, 0.25);
}
.version-banner__text {
    font-size: 0.95rem;
}
.version-banner__cta {
    background: #fff;
    color: #f80606;
    padding: 0.3rem 0.95rem;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.9rem;
    text-decoration: none;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.version-banner__cta:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    color: #b30505;
    text-decoration: none;
}
.version-banner__emoji {
    display: inline-block;
    transform-origin: 70% 70%;
    animation: emojiTada 2.2s ease-in-out infinite;
}
.version-banner__sport-icon {
    font-size: 1.05rem;
    margin: 0 0.2rem;
    vertical-align: -0.08em;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
}
.version-banner__sport-icon--run {
    animation: sportRun 1.6s ease-in-out infinite;
}
.version-banner__sport-icon--bike {
    animation: sportBike 2s ease-in-out infinite;
}
@keyframes emojiTada {
    0%, 50%, 100% {
        transform: scale(1) rotate(0deg);
    }
    10%, 20% {
        transform: scale(0.9) rotate(-8deg);
    }
    30%, 42% {
        transform: scale(1.15) rotate(8deg);
    }
    36% {
        transform: scale(1.15) rotate(-8deg);
    }
}
@keyframes sportRun {
    0%, 100% { transform: translateX(0) translateY(0); }
    25% { transform: translateX(2px) translateY(-2px); }
    50% { transform: translateX(4px) translateY(0); }
    75% { transform: translateX(2px) translateY(-1px); }
}
@keyframes sportBike {
    0%, 100% { transform: translateX(0) rotate(0deg); }
    50% { transform: translateX(4px) rotate(-4deg); }
}
@media (prefers-reduced-motion: reduce) {
    .version-banner__emoji,
    .version-banner__sport-icon--run,
    .version-banner__sport-icon--bike {
        animation: none;
    }
}
.version-banner__close {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: 0;
    color: #fff;
    font-size: 1.5rem;
    line-height: 1;
    padding: 0 0.4rem;
    cursor: pointer;
    opacity: 0.85;
}
.version-banner__close:hover {
    opacity: 1;
}
@media (max-width: 575px) {
    .version-banner {
        flex-direction: column;
        gap: 0.4rem;
        padding: 0.5rem 2.25rem 0.5rem 0.75rem;
    }
    .version-banner__text {
        font-size: 0.82rem;
    }
}

.modern-nav {
    position: relative;
    background:
        radial-gradient(ellipse 70% 120% at 18% 20%, rgba(248, 6, 6, 0.22), transparent 65%),
        radial-gradient(ellipse 60% 100% at 85% 80%, rgba(125, 211, 252, 0.12), transparent 70%),
        linear-gradient(125deg, #3a4656 0%, #44525f 42%, #4c4756 72%, #6b4550 100%);
    border-bottom: 2px solid rgba(248, 6, 6, 0.45);
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.14);
    padding: 0.55rem 1.25rem;
    gap: 0.75rem;
    overflow: hidden;
}
.modern-nav::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
    pointer-events: none;
}
.modern-nav__brand {
    padding: 0;
    margin-right: 0.75rem;
    display: flex;
    align-items: center;
}
.modern-logo {
    width: auto;
    height: 44px;
    display: block;
    padding-left: 0px;
}
.modern-nav__title-wrap {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1 1 auto;
}
.modern-title {
    margin: 0;
    color: #f8fafc;
    font-family: 'Segoe UI', system-ui, -apple-system, 'Helvetica Neue', sans-serif;
    font-weight: 700;
    font-size: 1.35rem;
    letter-spacing: -0.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: none;
    padding: 0;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}
.modern-title--sm {
    font-size: 1rem;
    white-space: normal;
    line-height: 1.2;
    text-overflow: clip;
    overflow: visible;
    word-break: break-word;
}
.modern-inicio-btn {
    background: #f80606;
    border: 0;
    color: #fff;
    font-weight: 600;
    padding: 0.45rem 1.2rem;
    border-radius: 10px;
    letter-spacing: 0.01em;
    box-shadow: 0 2px 8px rgba(248, 6, 6, 0.25);
    transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}
.modern-inicio-btn:hover,
.modern-inicio-btn:focus,
.modern-inicio-btn:active {
    background: #d40505 !important;
    border-color: #d40505 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(248, 6, 6, 0.35);
}

.LayoutDefault__main {
    position: relative;
    min-height: 60vh;
    background-color: #fafbfc;
    background-image:
        radial-gradient(ellipse 55% 45% at 8% 12%, rgba(248, 6, 6, 0.08), transparent 65%),
        radial-gradient(ellipse 50% 40% at 92% 18%, rgba(125, 211, 252, 0.09), transparent 70%),
        radial-gradient(ellipse 60% 45% at 50% 55%, rgba(68, 82, 95, 0.05), transparent 70%),
        radial-gradient(ellipse 55% 45% at 15% 95%, rgba(248, 6, 6, 0.06), transparent 70%),
        radial-gradient(ellipse 50% 40% at 85% 92%, rgba(52, 134, 124, 0.07), transparent 70%);
    background-attachment: scroll;
}
.LayoutDefault__main::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(15, 23, 42, 0.025) 1px, transparent 1px);
    background-size: 22px 22px;
    pointer-events: none;
    opacity: 0.6;
}
.LayoutDefault__main > * {
    position: relative;
    z-index: 1;
}

.LayoutDefault__footer {
    margin-top: 3rem;
    padding: 1.5rem 1rem;
    text-align: center;
    color: #94a3b8;
    font-size: 0.85rem;
    border-top: 1px solid rgba(15, 23, 42, 0.06);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.35rem;
    font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
    letter-spacing: 0.02em;
}
.footer-brand {
    font-weight: 600;
    color: #64748b;
}
.footer-copy {
    color: #cbd5e1;
}

@media (max-width: 767px) {
    .modern-nav {
        padding: 0.5rem 0.6rem;
        gap: 0.4rem;
    }
    .modern-nav__brand {
        margin-right: 0.35rem;
    }
}

@media (max-width: 575px) {
    .modern-logo { height: 36px; }
    .modern-title { font-size: 1.05rem; }
    .modern-title--sm { font-size: 0.8rem; line-height: 1.15; }
    .modern-inicio-btn { padding: 0.35rem 0.7rem; font-size: 0.82rem; }
}

@media (max-width: 380px) {
    .modern-logo { height: 32px;}
    .modern-title--sm { font-size: 0.72rem; }
    .modern-inicio-btn { padding: 0.3rem 0.55rem; font-size: 0.76rem; }
}
</style>
